(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-accordion]').forEach(function (item) {
    var btn = item.querySelector('.accordion-header');
    var body = item.querySelector('.accordion-body');

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        body.style.height = body.scrollHeight + 'px';
        body.offsetHeight;
        body.classList.add('is-animating');
        body.style.transition = 'height 0.3s ease';
        body.style.height = '0';
        body.addEventListener('transitionend', function handler() {
          body.removeAttribute('style');
          body.classList.remove('is-animating');
          body.setAttribute('hidden', '');
          body.removeEventListener('transitionend', handler);
        });
        btn.setAttribute('aria-expanded', 'false');
      } else {
        body.removeAttribute('hidden');
        body.classList.add('is-animating');
        var h = body.scrollHeight;
        body.style.height = '0';
        body.style.overflow = 'hidden';
        body.style.transition = 'height 0.3s ease';
        body.offsetHeight;
        body.style.height = h + 'px';
        body.addEventListener('transitionend', function handler() {
          body.removeAttribute('style');
          body.classList.remove('is-animating');
          body.removeEventListener('transitionend', handler);
        });
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-product-tabs"] && !Shopify.designMode) return;
  try {
    
    (function () {
  document.querySelectorAll('.premium-product-info-section').forEach(function(root){


      function initPremiumProductInfo(container) {
        var tabButtons = container.querySelectorAll('.premium-tab-btn');
        var tabPanels = container.querySelectorAll('.premium-tab-panel');
        var sectionWrapper = container.querySelector('.premium-section-wrapper');

        function getHeaderOffset() {
          var rootStyles = getComputedStyle(container);
          var headerHeight = parseInt(rootStyles.getPropertyValue('--site-header-height')) || 0;
          return headerHeight + 30;
        }

        tabButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            tabButtons.forEach(function (btn) { btn.setAttribute('aria-selected', 'false'); });
            tabPanels.forEach(function (panel) { panel.classList.remove('is-active'); });

            button.setAttribute('aria-selected', 'true');

            var panelId = button.getAttribute('aria-controls');
            var activePanel = container.querySelector('#' + panelId);
            if (activePanel) {
              activePanel.classList.add('is-active');
            }

            if (sectionWrapper) {
              var offset = sectionWrapper.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
              if (window.scrollY > offset) {
                window.scrollTo({ top: offset, behavior: 'smooth' });
              }
            }
          });

          button.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              button.click();
            }
          });
        });

        var accordions = container.querySelectorAll('.premium-accordion-trigger');
        accordions.forEach(function (accordion) {
          accordion.addEventListener('click', function () {
            var isExpanded = accordion.getAttribute('aria-expanded') === 'true';
            var content = accordion.nextElementSibling;

            accordions.forEach(function (acc) {
              if (acc !== accordion) {
                acc.setAttribute('aria-expanded', 'false');
                acc.nextElementSibling.style.maxHeight = null;
              }
            });

            if (isExpanded) {
              accordion.setAttribute('aria-expanded', 'false');
              content.style.maxHeight = null;
            } else {
              accordion.setAttribute('aria-expanded', 'true');
              content.style.maxHeight = content.scrollHeight + 'px';
            }
          });
        });

        container.addEventListener('shopify:section:load', function () {
          initPremiumProductInfo(container);
        });

        window.addEventListener('resize', function () {
          var openAccordions = container.querySelectorAll('.premium-accordion-trigger[aria-expanded="true"]');
          openAccordions.forEach(function (acc) {
            acc.nextElementSibling.style.maxHeight = acc.nextElementSibling.scrollHeight + 'px';
          });
        });
      }

      initPremiumProductInfo(root);
});
})();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wk-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wk-bestsellers')) {
    class WkBestsellers extends HTMLElement {
      connectedCallback() {
        this.status = this.querySelector('[data-wk-status]');
        this.onClick = (event) => {
          const swatch = event.target.closest('[data-wk-swatch]');
          if (swatch && this.contains(swatch)) return this.selectSwatch(swatch);
          const add = event.target.closest('[data-wk-add]');
          if (add && this.contains(add)) return this.addToCart(add);
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      selectSwatch(swatch) {
        const card = swatch.closest('[data-wk-card]');
        if (!card) return;

        card.querySelectorAll('[data-wk-swatch]').forEach((el) => {
          el.setAttribute('aria-pressed', el === swatch ? 'true' : 'false');
        });

        const name = card.querySelector('[data-wk-swatch-name]');
        if (name) name.textContent = swatch.getAttribute('aria-label') || '';

        const img = card.querySelector('.wk-bs__img:not(.wk-bs__img--hover)');
        if (img && swatch.dataset.src) {
          img.srcset = swatch.dataset.srcset || '';
          img.src = swatch.dataset.src;
        }

        card.querySelectorAll('[data-wk-link]').forEach((link) => {
          if (swatch.dataset.url) link.href = swatch.dataset.url;
        });

        const price = card.querySelector('[data-wk-price]');
        if (price) {
          const now = document.createElement('span');
          now.className = 'wk-bs__now';
          now.textContent = swatch.dataset.price || '';
          price.replaceChildren(now);
          if (swatch.dataset.compare) {
            const was = document.createElement('s');
            was.className = 'wk-bs__was';
            was.textContent = swatch.dataset.compare;
            price.append(was);
          }
        }

        const chip = card.querySelector('[data-wk-chip]');
        if (chip) {
          const off = Number(swatch.dataset.off || 0);
          chip.hidden = off <= 0;
          chip.textContent = off > 0 ? `${off}% off` : '';
        }

        const button = card.querySelector('[data-wk-add]');
        if (button) {
          const available = swatch.dataset.available === 'true';
          button.dataset.variantId = swatch.dataset.variantId;
          button.disabled = !available;
          this.setButtonText(button, available ? button.dataset.labelAdd : button.dataset.labelSoldout);
        }
      }

      setButtonText(button, text) {
        const label = button.querySelector('[data-wk-btn-text]');
        if (label) label.textContent = text;
      }

      async addToCart(button) {
        if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
        const variantId = Number(button.dataset.variantId);
        if (!variantId) return;

        const card = button.closest('[data-wk-card]');
        button.setAttribute('aria-busy', 'true');
        button.classList.add('is-loading');

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        try {
          const addUrl = `${this.dataset.cartAddUrl}.js`;
          const body = { items: [{ id: variantId, quantity: 1 }] };
          if (sectionIds.length) body.sections = sectionIds.join(',');

          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Add to cart failed');

          const cartResponse = await fetch(`${this.dataset.rootUrl.replace(/\/$/, '')}/cart.js`, {
            headers: { Accept: 'application/json' }
          });
          const cart = cartResponse.ok ? await cartResponse.json() : undefined;

          /* Same event shape the theme's product form fires, so the header
             count, cart drawer items and drawer all update themselves. */
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: String(variantId),
                data: {
                  source: 'product-form-component',
                  itemCount: 1,
                  productId: card ? card.dataset.productId : undefined,
                  sections: result.sections
                }
              }
            })
          );
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));

          button.classList.remove('is-loading');
          button.classList.add('is-added');
          this.setButtonText(button, button.dataset.labelAdded);
          if (this.status) this.status.textContent = button.dataset.labelAdded;

          if (this.dataset.openCart === 'true') {
            const drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            else if (document.querySelector('cart-drawer')) document.dispatchEvent(new Event('cart:open'));
            else window.location.href = this.dataset.cartUrl;
          }

          window.setTimeout(() => {
            button.classList.remove('is-added');
            this.setButtonText(button, button.dataset.labelAdd);
          }, 2200);
        } catch (error) {
          console.error(error);
          button.classList.remove('is-loading');
          this.setButtonText(button, button.dataset.labelError);
          if (this.status) this.status.textContent = error.message;
          window.setTimeout(() => this.setButtonText(button, button.dataset.labelAdd), 2500);
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('wk-bestsellers', WkBestsellers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wk-carrier-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wk-compare')) {
    class WkCompare extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-wk-track]');
        this.cards = Array.from(this.querySelectorAll('[data-wk-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-wk-dot]'));
        if (!this.track || this.dots.length === 0) return;

        this.active = 0;
        this.onScroll = () => {
          const index = this.closestIndex();
          if (index !== this.active) this.setActive(index);
        };
        this.onDot = (event) => {
          const dot = event.target.closest('[data-wk-dot]');
          if (!dot) return;
          const card = this.cards[Number(dot.dataset.wkDot)];
          if (!card) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('click', this.onDot);
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('click', this.onDot);
      }

      closestIndex() {
        const origin = this.cards[0].offsetLeft;
        const x = this.track.scrollLeft;
        let best = 0;
        let bestDistance = Infinity;
        this.cards.forEach((card, i) => {
          const distance = Math.abs(card.offsetLeft - origin - x);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        return best;
      }

      setActive(index) {
        this.active = index;
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('wk-compare', WkCompare);
  }

  } catch(e) { console.error(e); }
})();
})();
